/**
 * Team Card — frontend behaviour (view.js).
 *
 * Loaded only on pages that contain the block (declared as viewScript in
 * block.json). Handles bio overlay toggle, single-open across the page,
 * keyboard dismissal, and inert/ARIA management.
 *
 * Relies on CSS for the open/close transition (opacity + visibility).
 * JS only manages classes, ARIA attributes, inert, and focus.
 *
 * @package Vertaview
 * @author  Little Dash <hello@littledash.com.au>
 */

( function () {
	'use strict';

	const cards = [
		...document.querySelectorAll(
			'.wp-block-vertaview-team-card[data-team-card]'
		),
	];

	if ( ! cards.length ) return;

	// -------------------------------------------------------------------------
	// Open / close helpers
	// -------------------------------------------------------------------------

	function openCard( card ) {
		// Enforce single-open across all cards on the page.
		cards.forEach( ( other ) => {
			if ( other !== card ) closeCard( other );
		} );

		const overlay   = card.querySelector( '[data-team-card-overlay]' );
		const closedDiv = card.querySelector( '[data-team-card-closed]' );
		const trigger   = card.querySelector( '[data-bio-trigger]' );

		card.classList.add( 'is-open' );

		if ( overlay ) {
			overlay.inert = false;
			overlay.setAttribute( 'aria-hidden', 'false' );
		}

		// Hide closed-state content from keyboard and AT while overlay is visible.
		if ( closedDiv ) closedDiv.inert = true;

		if ( trigger ) trigger.setAttribute( 'aria-expanded', 'true' );

		// Move focus into the overlay so keyboard users land in the bio.
		const closeBtn = card.querySelector( '[data-bio-close]' );
		if ( closeBtn ) closeBtn.focus();
	}

	function closeCard( card ) {
		if ( ! card.classList.contains( 'is-open' ) ) return;

		const overlay   = card.querySelector( '[data-team-card-overlay]' );
		const closedDiv = card.querySelector( '[data-team-card-closed]' );
		const trigger   = card.querySelector( '[data-bio-trigger]' );

		card.classList.remove( 'is-open' );

		if ( overlay ) {
			overlay.inert = true;
			overlay.setAttribute( 'aria-hidden', 'true' );
		}

		if ( closedDiv ) closedDiv.inert = false;

		if ( trigger ) trigger.setAttribute( 'aria-expanded', 'false' );
	}

	// -------------------------------------------------------------------------
	// Per-card event wiring
	// -------------------------------------------------------------------------

	cards.forEach( ( card ) => {
		const trigger  = card.querySelector( '[data-bio-trigger]' );
		const closeBtn = card.querySelector( '[data-bio-close]' );

		// Bio → button — toggles the overlay open or closed.
		if ( trigger ) {
			trigger.addEventListener( 'click', () => {
				if ( card.classList.contains( 'is-open' ) ) {
					closeCard( card );
					trigger.focus(); // Return focus to the trigger on self-close.
				} else {
					openCard( card );
				}
			} );
		}

		// Close button inside the overlay — always closes.
		if ( closeBtn ) {
			closeBtn.addEventListener( 'click', () => {
				closeCard( card );
				// Return focus to the trigger so the user stays in logical order.
				const t = card.querySelector( '[data-bio-trigger]' );
				if ( t ) t.focus();
			} );
		}

		// Escape key dismisses an open overlay from anywhere inside the card.
		card.addEventListener( 'keydown', ( e ) => {
			if (
				e.key === 'Escape' &&
				card.classList.contains( 'is-open' )
			) {
				closeCard( card );
				const t = card.querySelector( '[data-bio-trigger]' );
				if ( t ) t.focus();
			}
		} );
	} );
} )();
